import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

// NOTE: NSAI-7410 — a flat vector rendition of Power Automate's chevron mark,
// traced from Pipedream's raster logo (the vendored PNG renders first; this is
// the fallback). Three bands in the brand blues #155fd8 (hsl 217 82% 47%),
// #3285f2 (hsl 214 88% 57%) and #63b4fc (hsl 208 96% 69%), each tinted from its
// own hue. The square viewBox is centred on the mark's bounding box.
const PowerAutomateComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="58 50 280 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="hsl(from hsl(217 82% 47%) h s 47%)"
      d="M87,83H239L146.6,189.8L76,105Q57,83 87,83Z"
    />
    <path
      fill="hsl(from hsl(214 88% 57%) h s 57%)"
      d="M239,83L285,137L146,297H82Q53,297 75,272L146.6,189.8Z"
    />
    <path
      fill="hsl(from hsl(208 96% 69%) h s 69%)"
      d="M285,137L321.7,179Q331,189 321,200L245,288Q237,297 228,297H146Z"
    />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components.
export const PowerAutomate = memo(PowerAutomateComponent);
